import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { Dimension, Location } from '@frontend/common';
import { StockExtended } from '@frontend/stock/types';
import { ExtendedTransaction } from '@frontend/transaction/types';

export interface SlotRendering {
    id: string;
    account_id: string;
    spot_id: string;
    module_id: string;
    index: number;
    number: string | null;
    display: string | null;
    row: number | null;
    column: number | null;
    location: Location | null;
    absolute: Location | null;
    dimension: Dimension | null;
    type: string;
    status: string;
    occupied: boolean;
    /** When false, the SLOT must not be drawn in spot layout. Missing/true = render. */
    renderable?: boolean;
    transactions: ExtendedTransaction[];
    stocks: StockExtended[];
}

/** Spot layout: skip SLOTs the API marks as non-renderable. */
export const isSlotRenderingRenderable = (slot: Pick<SlotRendering, 'renderable'>): boolean => slot.renderable !== false;

export type SlotRenderingListResponse = PaginatedResponse<SlotRendering>;
export type SlotRenderingQueryParams = DefaultQueryParams;
